import { RequestReason } from "./RequestReason"

export const REQUEST_REASON_DEFINITIONS: RequestReason[] = [
  { id: 1, value: "作品が好きだから" },
  { id: 2, value: "制作者のファンだから" },
  { id: 3, value: "作者を応援するため" },
  { id: 4, value: "作中の表現で気になる箇所があったから" },
]
